import getFeatureFlags from '@/api/stargate'

export default {
  async install(Vue) {
    const { modularOnboardingFlag, redirectToPatientAppFlag } = await getFeatureFlags()
    Object.defineProperty(Vue.prototype, '$modularOnboardingEnabled', {
      value: modularOnboardingFlag
    })
    Object.defineProperty(Vue.prototype, '$redirectToPatientAppFlag', {
      value: redirectToPatientAppFlag
    })
  }
}
